import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import Button from "../../components/Button";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import Badge from "../../components/Badge";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import useStyles from "./styles";
import ButtonCount from "../../components/ButtonCount";
import { httprequest } from "../../data/api";
import InputGroup from "../../components/FormComponent/InputGroup";
import { toast } from "react-toastify";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import useWindowSize from "../../hooks/useWindow";
import useValidator from "../../hooks/useValidator";
import PageLoader from "../../components/PageLoader";
import Tooltip from "@mui/material/Tooltip";
import { accessViewAllInventoryCategories, accessDeleteInventoryCategory, accessUpdateInventoryCategory, accessCreateInventoryCategory, accessUpdateInventoryItem, accessDeleteInventoryItem, accessAddInventoryItem } from "../../data/roles";
import { useUserState } from "../../context/UserContext";

const INVENTORY_ENDPOINT = "/api/v1/inventory";
const INVENTORY_CATEGORY_ENDPOINT = "/api/v1/inventory/category";

const Inventory = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState([]);
  const [editInventoryCategoryModal, setEditCategoryModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [currentDelete, setCurrentDelete] = useState({});
  const [addinventoryModal, setInventoryModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [archiving, setIsArchiving] = useState(false);
  const [inventoryCategoryValidator, showInventoryCategoryValidator] = useValidator();
  const [editInventoryValidator, showEditInventoryValidator] = useValidator();
  const [manageCategoryModal, setManageCategoryModal] = useState(false);
  const [deleteInvCategoryModal, setDeleteInvCategoryModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [manageArr, setManageArr] = useState([""]);
  const { userRole } = useUserState();
  const [manageForm, setManageForm] = useState({
    categories: [{ category: "" }]
  });
  const [editInvCategory, setEditInvCategory] = useState({
    category: ""
  });
  const width = useWindowSize();
  const mobile = width < 600;

  // --| Handle the change in the manage category input
  const handleManageChange = (e, index) => {
    const { value } = e.target;
    const allItems = [...manageArr];
    allItems[index] = value;
    setManageArr(allItems);
    const formattedCategories = allItems?.map(item => ({ category: item }));
    setManageForm({ categories: formattedCategories });
  };

  // --| Handle the delete of a manage item
  const handleDeleteManageItem = (index) => {
    const newItem = manageArr.filter((_item, ind) => ind !== index);
    setManageArr(newItem);

    const formatted = newItem.map(item => ({ category: item }));
    setManageForm({ categories: formatted });
  };

  // --| Add an additional item to the manage category
  const addAdditional = () => {
    const newItem = "";
    const updatedArr = [...manageArr, newItem];
    setManageArr(updatedArr);

    const formatted = updatedArr.map(item => ({ category: item }));
    setManageForm({ categories: formatted });
  };

  // --| Handle the manage category modal
  const handleManageCategoryModal = () => {
    setManageCategoryModal(!manageCategoryModal);

    const initial = [""];
    setManageArr(initial);
    setManageForm({ categories: initial.map(item => ({ category: item })) });
  };

  // --| Handle the close of the edit options modal
  const handleCloseEditOptionsModal = () => {
    setCurrentRow({});
    setEditInvCategory({ ...editInvCategory, category: "" });
    setEditCategoryModal(false);
  };

  // --| Get all inventory categories
  const getAllInvCategory = () => {
    // setIsCategoryFetching(true);
    httprequest.get(INVENTORY_CATEGORY_ENDPOINT).then((res) => {
      // setIsCategoryFetching(false);

      setCategoryData(res?.data?.data);
    }).catch((err) => {
      // setIsCategoryFetching(false);
      toast.error(err?.response?.data);
    });
  };

  // --| Handle the creation of inventory category
  const handleCreateInvCategory = () => {
    if (inventoryCategoryValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(INVENTORY_CATEGORY_ENDPOINT, manageForm).then((res) => {
        setIsLoading(false);
        toast.success(res?.data?.message);
        getAllInvCategory();
        // setInventoryCategory({ ...inventoryCategory, category: "" });
        handleManageCategoryModal();
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data);
      });
    } else {
      showInventoryCategoryValidator(true);
    }
  };

  // --| Handle the change in the edit inventory category input
  const handleEditCategoryChange = (e) => {
    const { name, value } = e.target;
    setEditInvCategory({ ...editInvCategory, [name]: value });
  };

  const handleCloseDeleteCategoryModal = () => {
    setDeleteInvCategoryModal(false);
    setCurrentDelete({});
  };

  // --| Handle the deletion of inventory category
  const handleDeleteInvCategory = () => {
    setIsDeleteLoading(true);
    httprequest.delete(`${INVENTORY_CATEGORY_ENDPOINT}/${currentDelete?.id}`).then(() => {
      setIsDeleteLoading(false);
      toast.success("Invemtory Category Deleted Successfully");
      getAllInvCategory();
      handleManageCategoryModal();
      handleCloseDeleteCategoryModal();
    }).catch((err) => {
      setIsDeleteLoading(false);
      toast.error(err?.response?.data);
    });
  };

  // --| Handle the edit of inventory category
  const handleEditInvCategory = () => {
    if (editInventoryValidator.allValid()) {
      setIsEditLoading(true);
      httprequest.patch(`${INVENTORY_CATEGORY_ENDPOINT}/${currentRow?.id}`, editInvCategory).then(() => {
        setIsEditLoading(false);
        toast.success("Invoice Category Edited");
        getAllInvCategory();
        setEditInvCategory({ ...editInvCategory, category: "" });
        handleCloseEditOptionsModal();
        handleManageCategoryModal();
      }).catch((err) => {
        setIsEditLoading(false);
        toast.error(err?.response?.data?.message);
        handleCloseEditOptionsModal();
      });
    } else {
      showEditInventoryValidator(true);
    }
  };

  // --| Handle the close of the inventory modal
  const handleCloseInventoryModal = () => {
    setInventoryModal(false);
    setCurrentRow({});
  };

  // --| Handle the opening of the inventory modal
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  // --| Handle the edit inventory modal
  const handleEditInvModal = (row) => {
    setCurrentRow(row);
    setEditInvCategory({ ...editInvCategory, category: row?.category });
    setEditCategoryModal(true);
  };

  // --| Handle the delete category modal
  const handleDeletCategoryModal = (row) => {
    setDeleteInvCategoryModal(true);
    setCurrentDelete(row);
  };

  // --| Handle the archive modal
  const handleArchive = (row) => {
    setCurrentRow(row);
    setArchiveModal(!archiveModal);
  };

  // --| Handle the close of the delete modal
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setCurrentRow({});
  };

  // --| Handle the close of the archive modal
  const handleCloseArchiveModal = () => {
    setArchiveModal(false);
    setCurrentRow({});
  };

  // const getAllInvCategory = () => {
  //   httprequest.get(INVENTORY_CATEGORY_ENDPOINT).then((res) => {
  //     setCategoryCount(res?.data?.data?.length);
  //   }).catch((err) => {
  //     toast.error(err?.response?.data);
  //   });
  // };

  // --| Handle the filter based on selected status
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "used"
      ? inventoryData?.filter((data) => data?.condition === "used")
      : value === "new"
        ? inventoryData?.filter((data) => data?.condition === "new")
        : value === "broken"
          ? inventoryData?.filter((data) => data?.condition === "broken")
          : value === "good"
            ? inventoryData?.filter((data) => data?.condition === "good")
            : value === "poor"
              ? inventoryData?.filter((data) => data?.condition === "poor")
              : value === "damaged"
                ? inventoryData?.filter((data) => data?.condition === "damaged")
                : value === "others"
                  ? inventoryData?.filter((data) => data?.condition === "otherrs")
                  : inventoryData;
    setSearchResult(filteredByStatus);
  };

  // --| Get all inventory data
  const getAllInventory = () => {
    setIsLoading(true);
    httprequest.get(INVENTORY_ENDPOINT).then((res) => {
      setIsLoading(false);
      setInventoryData(res?.data?.data?.inventories);
      setSearchResult(res?.data?.data?.inventories);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data);
    });
  };

  // --| Handle the delete of inventory
  const handleDeleteInventory = () => {
    setIsDeleting(true);
    httprequest.delete(`${INVENTORY_ENDPOINT}/${currentRow?.id}`).then(() => {
      setIsDeleting(false);
      handleCloseDeleteModal();
      getAllInventory();
      toast.success("Inventory Deleted");
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data);
    });
  };

  // --| Handle the archiving of inventory
  const handleArchiveInventory = () => {
    setIsArchiving(true);
    httprequest.patch(`${INVENTORY_ENDPOINT}/${currentRow?.id}`, { status: "archived" }).then(() => {
      setIsArchiving(false);
      handleCloseArchiveModal();
      getAllInventory();
      toast.success("Inventory Archived Succesfully");
    }).catch((err) => {
      setIsArchiving(false);
      toast.error(err?.response?.data);
    });
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    // The data will be from the inventory get api endpint
    getAllInventory();
    getAllInvCategory();
  }, []);
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Employee In-Charge",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Employee In-Charge</p>}
          {`${row?.employee_in_charge?.last_name} ${row?.employee_in_charge?.first_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Category",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Category</p>}
          {row?.category?.category || "--/--"}
        </>
      )
    },
    {
      name: "Condition",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Condition</p>}
          <Badge status={row?.condition} />
        </>
      )
    },
    {
      name: "Created At",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => navigate(`/inventory/view-inventory/${row?.id}`)}
            className="table-action-icon"
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          {accessUpdateInventoryItem(userRole) && (
            <Link to={`/inventory/${row?.id}`} className="table-action-icon">
              <button className="table-action-icon">
                <Icon icon="heroicons:pencil-square-solid" />
              </button>
            </Link>
          )}
          <button
            onClick={() => handleArchive(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="material-symbols:archive-outline" />
          </button>
          {/* {row?.status === "active" ? (
            <button
              onClick={() => handleArchive(row)}
              className="table-action-icon delete-icon"
            >
              <Icon icon="material-symbols:archive-outline" />
            </button>
          ) : (
            <button
              onClick={() => handleArchive(row)}
              className="table-action-icon delete-icon"
            >
              <Icon icon="clarity:unarchive-line" />
            </button>
          )} */}
          {accessDeleteInventoryItem(userRole) && (
            <button
              onClick={() => handleDeleteModal(row)}
              className="table-action-icon delete-icon"
            >
              <Icon icon="mingcute:delete-2-line" />
            </button>
          )}
        </div>
      )
    }
  ];

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    const filteredByStatus = filterStatus
      ? inventoryData?.filter((data) => data?.status?.toLowerCase() === filterStatus?.toLowerCase())
      : inventoryData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.condition
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.category?.category
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.status
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Inventory"
            subtitle="See the inventory of all items gotten."
            button={
              <div className="flex gap-10">
                <Button onClick={() => {
                  navigate("/inventory/archive-inventory");
                }} variant="primaryoutline" buttonSize="small" color="btnfontprimary" buttonName="View Archive"
                />
                {accessAddInventoryItem(userRole) && (
                  <Button onClick={() => {
                    navigate("/inventory/create");
                  }} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Inventory"
                  />
                )}
              </div>
            }
          />
          <div className="page-content">
            <div className="button-count-container">
              <ButtonCount title="Inventory" count={inventoryData?.length} />
            </div>
            {isLoading ? (
              <PageLoader />
            ) : (
              <>
                <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                  <div className="action_div">
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInventory} isLoading={isLoading} />
                    <div className="flex gap-10">
                      {accessViewAllInventoryCategories(userRole) && (
                        <div className={classes.actionitem}>
                          <p onClick={() => navigate("/inventory/categories")}>Manage Categories</p>
                        </div>
                      )}
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Filter --</option>
                              <option value="new">New</option>
                              <option value="used">Used</option>
                              <option value="broken">Broken</option>
                              <option value="good">Good</option>
                              <option value="poor">Poor</option>
                              <option value="damaged">damaged</option>
                              <option value="others">Others</option>
                            </select>
                          }
                        />
                      </div>
                    </div>
                  </div>
                }
                />
              </>
            )}
            {/*  */}
            <Modal
              title={`Library Order Inventory ${currentRow?.name}`}
              subtitle={
                <div>See the details of the item selected.
                </div>}
              modalContent={
                <>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Product Name"
                        margin="normal"
                        placeHolder="Enter product name"
                        inputType="text"
                        value={currentRow?.name}
                        disabled
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Employee in Charge"
                        margin="normal"
                        inputType="text"
                        value={`${currentRow?.employee_in_charge?.last_name} ${currentRow?.employee_in_charge?.first_name}`}
                        disabled
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Status"
                        margin="normal"
                        inputType="text"
                        value={currentRow?.status}
                        disabled
                      />
                    </Grid>
                    {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Issue Number"
                        margin="normal"
                        inputType="text"
                        value={currentRow?.issue_no}
                        disabled
                      />
                    </Grid> */}
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Category"
                        margin="normal"
                        inputType="text"
                        value={currentRow?.category?.category}
                        disabled
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Quantity"
                        margin="normal"
                        inputType="text"
                        value={currentRow?.quantity}
                        disabled
                      />
                    </Grid>
                    {currentRow?.images?.length > 0 && (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className={classes.imageitems}><p>Images</p></div>
                        <Grid container spacing={2}>
                          {currentRow?.images.map((option, i) => (
                            <Grid item lg={2} md={2} sm={4} xs={3} key={i}>
                              <img
                                src={option?.file_url}
                                alt={`Option ${i + 1}`}
                                style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </>
              }
              modalFooter={
                <>
                  <div className={classes.modalFooterBtn}>
                    <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Download Inventory" />
                    <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Share inventory" />
                  </div>
                </>
              }
              isopen={addinventoryModal}
              closeModal={handleCloseInventoryModal}
            />
            {/* Delete Modal */}
            <Modal
              title="Delete Inventory"
              subtitle={
                <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.name}</span>. If deleted, employee will no longer have access to this Inventory.`
                </div>}
              modalContent={
                <>

                </>
              }
              modalFooter={
                <>
                  <Button variant="danger" buttonName="Delete Inventory" buttonSize="full" color="btndefault" onClick={handleDeleteInventory} isLoading={isDeleting} />
                </>
              }
              isopen={deleteModal}
              closeModal={handleCloseDeleteModal}
            />
            {/* Archive Modal */}
            <Modal
              title="Archive Inventory"
              subtitle={
                <div>Are you sure you want to archive <span className="modal-name-highlight">{currentRow?.name}</span>. If archived, employee will no longer have access to this Inventory.`
                </div>}
              modalContent={
                <>

                </>
              }
              modalFooter={
                <>
                  <Button variant="danger" buttonName="Archive Inventory" buttonSize="full" color="btndefault" onClick={handleArchiveInventory} isLoading={archiving} />
                </>
              }
              isopen={archiveModal}
              closeModal={handleCloseArchiveModal}
            />
            {/* Manage Category Modal */}
            <Modal
              title="Manage Inventory Category"
              subtitle={
                <div>Assign items to categories for better tracking and reporting.
                </div>}
              modalContent={
                <>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {categoryData?.map((item, index) => (
                        <div key={index} className={classes.manageitems}>
                          <InputGroup
                            inputName={`category-${index}`}
                            type="text"
                            label={`Category Name ${index + 1}`}
                            defaultValue={item?.category}
                            // onChange={(e) => handleEditChange(e, index)}
                            disabled
                          />
                          {editInventoryValidator.message(
                            `Category Name ${index}`,
                            item?.category,
                            "required"
                          )}
                          <div className={classes.actionitems}>
                            <div key={item?.id} className="table-action-container">
                              <Tooltip
                                title={
                                  <div>
                                    <div>Created: {new Date(item?.created_at).toLocaleString()}</div>
                                    <div>Updated: {new Date(item?.updated_at).toLocaleString()}</div>
                                  </div>
                                }
                                arrow
                                classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
                              >
                                <button className="table-action-icon">
                                  <Icon icon="ri:question-line" />
                                </button>
                              </Tooltip>
                              {accessUpdateInventoryCategory(userRole) && (
                                <button className="table-action-icon" onClick={() => {
                                  handleEditInvModal(item);
                                }}
                                >
                                  <Icon icon="heroicons:pencil-square-solid" />
                                </button>
                              )}
                              {accessDeleteInventoryCategory(userRole) && (
                                <button
                                  onClick={() => handleDeletCategoryModal(item)}
                                  className="table-action-icon delete-icon"
                                >
                                  <Icon icon="mingcute:delete-2-line" />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </Grid>
                    {accessCreateInventoryCategory(userRole) && (
                      manageForm?.categories?.length > 0 ? (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {manageArr?.map((item, index) => (
                            <div key={index} className={classes.manageitems}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <InputGroup
                                  label="Category Name"
                                  margin="normal"
                                  required
                                  placeHolder="Enter category name"
                                  inputType="text"
                                  inputName="category"
                                  onChange={(e) => handleManageChange(e, index)}
                                  value={item}
                                />
                                {inventoryCategoryValidator.message(`Category ${index + 1}`, manageForm?.categories[index]?.category, "required")}
                              </Grid>
                              <div className={classes.anitem}>
                                {manageForm?.categories?.length > 1 ? (
                                  <p
                                    className={classes.deleteitem}
                                    onClick={() => {
                                      handleDeleteManageItem(index);
                                    }}
                                  >
                                    {/* <Icon icon="zondicons:minus-solid" /> */}
                                                              Remove
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          ))}
                        </Grid>
                      ) : null
                    )}
                  </Grid>
                  {accessCreateInventoryCategory(userRole) && (
                    <div
                      className={`${classes.mail} flex align-items-center `}
                      onClick={addAdditional}
                    >
                      <p>Add Category</p>
                      <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                    </div>
                  )}
                </>
              }
              modalFooter={
                <>
                  {accessCreateInventoryCategory(userRole) && (
                    <Button variant="primary" buttonName="Create Category" buttonSize="full" color="btndefault" isLoading={isLoading} onClick={handleCreateInvCategory} />
                  )}
                </>
              }
              isopen={manageCategoryModal}
              closeModal={handleManageCategoryModal}
            />
            {/* Modal to edit inventory category */}
            <Modal
              title="Edit Inventory Category"
              subtitle="Edit your current inventory category"
              modalContent={
                <>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup inputName="category" type="text" label="Category Name" defaultValue={editInvCategory?.category} onChange={handleEditCategoryChange} />
                      {editInventoryValidator.message("Category Name", editInvCategory?.category, "required")}
                    </Grid>
                  </Grid>
                </>
              }
              modalFooter={
                <>
                  <Button
                    type="submit"
                    onClick={handleEditInvCategory}
                    variant="primary"
                    buttonName="Edit Inventory Category"
                    buttonSize="full"
                    color="btndefault"
                    isLoading={isEditLoading}
                  />
                </>
              }
              isopen={editInventoryCategoryModal}
              closeModal={handleCloseEditOptionsModal}
            />
            {/* Delete Category */}
            <Modal
              title="Delete Current Inventory Category"
              subtitle={`Are you sure you want to delete this  ${currentDelete?.category} inventory category?. If you delete it, it becomes unavaiable for the whole school.`}
              modalContent={
                <>
                  <div>
                  </div>
                </>
              }
              modalFooter={
                <>
                  <Button
                    type="submit"
                    variant="danger"
                    buttonName="Delete Inventory Category"
                    buttonSize="full"
                    color="btndefault"
                    onClick={handleDeleteInvCategory}
                    isLoading={isDeleteLoading}
                  />
                </>
              }
              isopen={deleteInvCategoryModal}
              closeModal={handleCloseDeleteCategoryModal}
            />
            {/* <ToastContainer /> */}
          </div>
        </>
      }
    />
  );
};

export default Inventory;
